module.exports = __webpack_public_path__ + "img/charge.dad91a7e.png";